import { CustomerService } from "@/services/api/customer.service";
import { basePagesMutations } from "@/store/base-pages";

const state = {
  items: [],
  meta: {
    total: 0,
  },
};

export default {
  namespaced: true,

  state: { ...state },

  mutations: {
    ...basePagesMutations,
  },

  actions: {
    removeItem({ commit, rootState }, allergy) {
      return CustomerService.removeAllergy(rootState.customer.id, allergy.id).then(response => {
        if (response.success) {
          commit("REMOVE_ITEM", allergy);
          commit("DECREASE_META_TOTAL");
        }
      });
    },
  },
};
